import React from "react";
import Card from "../../components/page/Card";
import EnvioDataTable from "./Envio/EnvioDataTable";
import useApi from "../../hooks/useApi";
import MensagensApiClient from "../../api/mensagens";
import EnviarModal from "./Envio/EnviarModal";
import CommonsHelper from "../../helpers/CommonsHelper";
import ErrorSwal from "../../components/Swal/errorSwal";
import Validation from "../../helpers/Validation";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import emojiToolkit from "emoji-toolkit";

function Envio() {
  const [contatos, setContatos] = React.useState([]);
  const [modelos, setModelos] = React.useState([]);
  const [checkboxesMarcados, setCheckboxesMarcados] = React.useState([]);
  const [envioModal, setEnvioModal] = React.useState(false);
  const [values, setValues] = React.useState({});
  const [modelo, setModelo] = React.useState({});

  const { request: getContatos, data: contatosResponse } = useApi(
    MensagensApiClient.getContatos
  );
  const { request: getModelos, data: modelosResponse } = useApi(
    MensagensApiClient.getModelos
  );
  const enviarMensagensApi = useApi(MensagensApiClient.enviarMensagens);

  //Busca mensagens ao renderizar tela
  React.useEffect(() => {
    getContatos();
  }, [getContatos]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (contatosResponse) setContatos(contatosResponse.empresas);
  }, [contatosResponse]);

  //Busca mensagens ao renderizar tela
  React.useEffect(() => {
    getModelos();
  }, [getModelos]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (modelosResponse) setModelos(modelosResponse);
  }, [modelosResponse]);

  //Define o estado do modelo de acordo com o modelo selecionado
  React.useEffect(() => {
    const modeloSelecionado = values.modelo
      ? modelos.find((modelo) => String(modelo.uid) === values.modelo)
      : { descricao: "" };

    setModelo({
      ...modeloSelecionado,
      descricao: emojiToolkit.shortnameToUnicode(modeloSelecionado.descricao),
    });
  }, [modelos, values.modelo]);

  const togEnviarModal = () => {
    if (checkboxesMarcados.length === 0)
      return ErrorSwal({ title: "Nenhum contato marcado." });
    setValues({});
    CommonsHelper.removeBodyCss();
    setEnvioModal(true);
  };

  const enviarMensagens = () => {
    OptionsSwal({
      icon: "warning",
      title: `Você está prestes a enviar essa mensagem para ${checkboxesMarcados.length} empresas. Deseja confirmar o envio?`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("contatos", JSON.stringify(checkboxesMarcados));
        formData.append("modelo", modelo?.nome);
        formData.append("mensagem", modelo?.descricao);
        for (let index = 1; index < modelo?.variaveis + 1; index++) {
          formData.append(`variavel_${index}`, values[`variavel_${index}`]);
          if (values[`variavel_${index}`] === "1")
            formData.append(
              `valor_variavel_${index}`,
              values[`valor_variavel_${index}`]
            );
        }
        if (Validation.verificarForm(formData))
          return ErrorSwal({
            text: "Favor preencher todos os dados obrigatórios.",
          });

        const response = await enviarMensagensApi.request(formData);
        if (!response) return;
        CommonSwal({
          icon: "info",
          title:
            "As mensagens estão sendo enviadas para todas as empresas selecionadas. Ao finalizar o processo, será enviado uma confirmação pelo Discord.",
        });
        setEnvioModal(false);
      }
    });
  };

  return (
    <>
      <Card>
        <EnvioDataTable
          linhas={contatos}
          checkboxesMarcadosHook={{ checkboxesMarcados, setCheckboxesMarcados }}
          togEnviarModal={togEnviarModal}
        />
      </Card>
      <EnviarModal
        isOpen={envioModal}
        setIsOpen={setEnvioModal}
        valuesHook={{ values, setValues }}
        modelos={modelos}
        modelo={modelo}
        enviarMensagens={enviarMensagens}
      />
    </>
  );
}

export default Envio;
